import { Injectable, signal, WritableSignal } from '@angular/core';

export interface HeaderTab {
    value: string;
    label: string;
    icon: string;
}

@Injectable({ providedIn: 'root' })
export class HeaderTabsService {
    readonly tabs = signal<HeaderTab[]>([]);
    readonly activeTab: WritableSignal<string> = signal('');
    readonly title = signal('');
    readonly titleIcon = signal('');

    register(tabs: HeaderTab[], defaultTab: string): void {
        this.tabs.set(tabs);
        this.activeTab.set(defaultTab);
        this.title.set('');
        this.titleIcon.set('');
    }

    setTitle(title: string, icon: string): void {
        this.title.set(title);
        this.titleIcon.set(icon);
        this.tabs.set([]);
        this.activeTab.set('');
    }

    clear(): void {
        this.tabs.set([]);
        this.activeTab.set('');
        this.title.set('');
        this.titleIcon.set('');
    }

    selectTab(value: string): void {
        this.activeTab.set(value);
    }
}
